import { CSSProperties, FC } from "react";

import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import SensorsIcon from "@mui/icons-material/Sensors";
import { Badge, Button, Tooltip } from "@mui/material";

import { Translate } from "@/components/Application/Translate";
import { CheckpointType } from "@/components/Procedures/Types/ManualChecklistTypes";

import { ProcedureNodeStep } from "@/model/Procedure/ProcedureNodeStep";

interface MeasurementStatusProps {
	checklistId: number | undefined;
	step: ProcedureNodeStep;
	materialHandling?: boolean;
	toggleShowMeasurements: () => void;
	stepSkipped: boolean;
	liveButtonStyle?: { button: CSSProperties } | undefined;
}

export const MeasurementStatus: FC<MeasurementStatusProps> = (props) => {
	if (
		props.step.CheckpointType !== CheckpointType.SATOSLive &&
		props.step.StepType !== "Measurement"
	) {
		return <></>;
	}

	return (
		<Badge
			badgeContent={
				<Tooltip
					placement="top"
					title={
						<Translate String="Live.Step.No.Listener">No listenertag</Translate>
					}
				>
					<ReportProblemIcon sx={{ fontSize: "10px" }} />
				</Tooltip>
			}
			color="warning"
			invisible={!!props.step.ListenerTags.length}
			sx={{ top: "8px", left: "8px", cursor: "help" }}
			anchorOrigin={{
				vertical: "top",
				horizontal: "left",
			}}
		>
			<Tooltip
				title={
					props.step.IsSkipped ? (
						<Translate String="Live.Step.Skipped">Step is skipped</Translate>
					) : (
						<Translate String="Live.Step.ShowListener">
							Show listeners
						</Translate>
					)
				}
			>
				<Button
					disabled={props.step.IsSkipped}
					sx={{ minWidth: "40px", ...props.liveButtonStyle?.button }}
					type="button"
					variant="contained"
					onClick={() => props.toggleShowMeasurements()}
				>
					<SensorsIcon />
				</Button>
			</Tooltip>
		</Badge>
	);
};
